import { IonSpinner } from '@ionic/react';
import React from 'react';
import styled from 'styled-components';

interface Props extends React.ComponentPropsWithoutRef<typeof IonSpinner> {
  $size?: 'small' | 'medium' | 'large';
  $centerFixed?: boolean;
}

const sizes = {
  small: '64px',
  medium: '128px',
  large: '200px',
};

const StyledSpinner = styled(IonSpinner)<Props>`
  ${({ $size }) => $size && `width: ${sizes[$size]}; height: ${sizes[$size]};`}
  ${({ $centerFixed }) =>
    $centerFixed &&
    `
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  `}
`;

export const Spinner = ({ $size = 'medium', ...props }: Props) => (
  <StyledSpinner name="circles" $size={$size} {...props} />
);
